import { API_PATHS } from '@/constants/api-paths'
import { api } from '@/lib/api'

export type ShiftTemplate = {
  id: number
  code: string
  label: string
  start_time: string
  end_time: string
  sort_order: number
  org_instance_id?: number
}

export type ShiftPreset = {
  code: string
  label: string
  start_time: string
  end_time: string
  saved: boolean
  id: number | null
}

export type ShiftTemplateCatalog = {
  presets: ShiftPreset[]
  templates: ShiftTemplate[]
}

function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return null
  }
  return value as Record<string, unknown>
}

function unwrapCatalog(payload: unknown): ShiftTemplateCatalog {
  const record = asRecord(payload)
  const nested = asRecord(record?.data)
  const source = nested && ('presets' in nested || 'templates' in nested) ? nested : record
  const presets = Array.isArray(source?.presets) ? source.presets as ShiftPreset[] : []
  const templates = Array.isArray(source?.templates) ? source.templates as ShiftTemplate[] : []
  return { presets, templates }
}

function unwrapTemplate(payload: unknown): ShiftTemplate {
  const record = asRecord(payload)
  const nested = asRecord(record?.data)
  const source = nested && 'id' in nested ? nested : record
  if (!source || source.id == null) {
    throw new Error('Missing shift template response.')
  }
  return source as unknown as ShiftTemplate
}

export const shiftTemplatesApi = {
  async list(): Promise<ShiftTemplateCatalog> {
    const response = await api.get(API_PATHS.shiftTemplates.list)
    return unwrapCatalog(response.data)
  },

  async add(code: string): Promise<ShiftTemplate> {
    const response = await api.post(API_PATHS.shiftTemplates.create, { code })
    return unwrapTemplate(response.data)
  },
}
